module.exports = __webpack_public_path__ + "static/media/validacao_cnpj_dark.4b4bcee1.svg";